module.exports = __webpack_public_path__ + "components/facebook-button/static/facebook-e4c11b5857a153243086512294946562.svg";